export default __webpack_public_path__ + "static/media/iconCameraSmall.4872e7b5.svg";